import { _js } from '@ifixit/localize';
import CodeBlock from 'Shared/icons/code-box-line.svg';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const CodeBlockButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleCodeBlock().run()}
         isActive={editor.isActive('codeBlock')}
         isDisabled={!editor.can().toggleCodeBlock()}
         icon={<CodeBlock />}
         /* Translators: "Code" as in monospaced font */
         title={_js('Insert code block')}
      ></TiptapButton>
   );
};
